module.exports = __webpack_public_path__ + "img/video_menu_mike_on.7c9ca7d6.svg";